// TheFirstTheLast Scroll Animation (ES Module)

// Canvas Animation for Introductory Content
class FloatingNotes {
     constructor(canvas) {
          this.canvas = canvas;
          this.ctx = canvas.getContext('2d');
          this.elements = [];
          this.animationId = null;
          this.imagesLoaded = false;

          this.resize();
          this.loadImages();
          this.createElements();
          this.animate();

          window.addEventListener('resize', () => this.resize());
     }

     resize() {
          this.canvas.width = this.canvas.offsetWidth;
          this.canvas.height = this.canvas.offsetHeight;
          this.centerX = this.canvas.width / 2;
          this.centerY = this.canvas.height / 2;
     }

     loadImages() {
          this.guitarImages = [];
          const guitarPaths = [
               '/assets/img/SDGDR/lereve/Impact1-ComfyUI_00016_.png',
               '/assets/img/SDGDR/lereve/Impact2-M13_Blanket_TwoPeople_00001_.png',
               '/assets/img/SDGDR/lereve/Impact3-E20_Group_Singalong.png',
               '/assets/img/SDGDR/lereve/SDGDR CouvertesGuitare.png',
               '/assets/img/SDGDR/lereve/Impact1-ComfyUI_00058_.png',
               '/assets/img/SDGDR/lereve/M03_Megaphone_Shelter_Door_00001_.png',
               '/assets/img/SDGDR/lereve/M04_Megaphone_Bridge_00001_.png',
               '/assets/img/SDGDR/lereve/M05_Megaphone_ParkBench_00001_.png',
               '/assets/img/SDGDR/lereve/G14_Light_Painting_Arc.png',
               '/assets/img/SDGDR/lereve/G21_Rainy_Window.png',
               '/assets/img/SDGDR/lereve/HonneteCitoyen.png',
               '/assets/img/SDGDR/SDR/2-SX6_Mirror_DoubleReflection_HeadstockKiss_00001_.png',
               '/assets/img/SDGDR/SDR/3-G22_Curtain_Peek.png',
               '/assets/img/SDGDR/SDR/4-SX1_FurRug_Sensual_Clothed_00001_V3.png',
               '/assets/img/SDGDR/SDR/5-P2_Peek_Behind_Guitar_Neck_00001_.png',
               '/assets/img/SDGDR/SDR/6-CL4_Case_Reveal_Vintage_00001_.png',
               '/assets/img/SDGDR/SDR/7-B3_Wide_Studio_RotateVariations_00001_.png'
          ];

          let loadedCount = 0;
          guitarPaths.forEach((path, index) => {
               const img = new Image();
               img.onload = () => {
                    loadedCount++;
                    if (loadedCount === guitarPaths.length) {
                         this.imagesLoaded = true;
                         this.createElements(); // Recreate elements now that images are loaded
                    }
               };
               img.src = path;
               this.guitarImages.push(img);
          });
     }

     createElements() {
          const noteSymbols = ['♪', '♫', '♬', '♩', '♭', '♯', '𝄞', '𝄢', '𝄡', '🎵', '🎶', '🎼', '🎸', '🎺', '🥁', '🎹', '🎧', '🎤'];
          this.elements = [];

          // Create 60 elements total (mix of notes and guitars)
          for (let i = 0; i < 60; i++) {
               const isGuitar = this.imagesLoaded && Math.random() > 0.3; // 70% chance for guitar if images loaded

               if (isGuitar && this.guitarImages.length > 0) {
                    // Guitar image element
                    const guitarImg = this.guitarImages[Math.floor(Math.random() * this.guitarImages.length)].cloneNode();
                    this.elements.push({
                         x: Math.random() * this.canvas.width,
                         y: Math.random() * this.canvas.height,
                         vx: (Math.random() - 0.5) * 0.6,
                         vy: (Math.random() - 0.5) * 0.6,
                         image: guitarImg,
                         width: Math.random() * 80 + 50, // Random size between 50-130px
                         height: Math.random() * 80 + 50,
                         opacity: Math.random() * 0.6 + 0.4, // More vibrant: 0.4-1.0 opacity
                         rotation: Math.random() * Math.PI * 2,
                         rotationSpeed: (Math.random() - 0.5) * 0.015,
                         type: 'guitar'
                    });
               } else {
                    // Musical note element
                    this.elements.push({
                         x: Math.random() * this.canvas.width,
                         y: Math.random() * this.canvas.height,
                         vx: (Math.random() - 0.5) * 0.8,
                         vy: (Math.random() - 0.5) * 0.8,
                         symbol: noteSymbols[Math.floor(Math.random() * noteSymbols.length)],
                         size: Math.random() * 35 + 25, // Larger size range: 25-60px
                         opacity: Math.random() * 0.7 + 0.3, // More vibrant: 0.3-1.0 opacity
                         rotation: Math.random() * Math.PI * 2,
                         rotationSpeed: (Math.random() - 0.5) * 0.02,
                         type: 'note'
                    });
               }
          }
     }

     animate() {
          this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

          this.elements.forEach(element => {
               // Update position
               element.x += element.vx;
               element.y += element.vy;
               element.rotation += element.rotationSpeed;

               // Wrap around edges
               if (element.x < -100) element.x = this.canvas.width + 100;
               if (element.x > this.canvas.width + 100) element.x = -100;
               if (element.y < -100) element.y = this.canvas.height + 100;
               if (element.y > this.canvas.height + 100) element.y = -100;

               // Draw element
               this.ctx.save();
               this.ctx.translate(element.x, element.y);
               this.ctx.rotate(element.rotation);
               this.ctx.globalAlpha = element.opacity;

               if (element.type === 'guitar' && element.image) {
                    // Draw guitar image
                    this.ctx.drawImage(
                         element.image,
                         -element.width / 2,
                         -element.height / 2,
                         element.width,
                         element.height
                    );
               } else {
                    // Draw musical note
                    this.ctx.fillStyle = getComputedStyle(document.documentElement).getPropertyValue('--color-text-primary').trim() || '#000';
                    this.ctx.font = `${element.size}px serif`;
                    this.ctx.textAlign = 'center';
                    this.ctx.textBaseline = 'middle';
                    this.ctx.fillText(element.symbol, 0, 0);
               }

               this.ctx.restore();
          });

          this.animationId = requestAnimationFrame(() => this.animate());
     }

     destroy() {
          if (this.animationId) {
               cancelAnimationFrame(this.animationId);
          }
          window.removeEventListener('resize', () => this.resize());
     }
}

document.addEventListener("DOMContentLoaded", () => {
     gsap.registerPlugin(ScrollTrigger);

     const lenis = new Lenis();
     lenis.on("scroll", ScrollTrigger.update);
     gsap.ticker.add((time) => {
          lenis.raf(time * 1000);
     });
     gsap.ticker.lagSmoothing(0);

     // Initialize canvas animation
     const canvas = document.getElementById('thefirstthelast-canvas');
     if (canvas) {
          const floatingNotes = new FloatingNotes(canvas);
     }

     const cards = gsap.utils.toArray(".thefirstthelast-card");
     const rotations = [-12, 10, -5, 5, -8, 3];

     // Set up intro content fade out animation
     const introElement = document.querySelector('.thefirstthelast-intro');
     if (introElement) {
          gsap.set(introElement, { autoAlpha: 1 });
     }

     cards.forEach((card, index) => {
          gsap.set(card, {
               y: window.innerHeight,
               rotate: rotations[index],
               autoAlpha: 0,
          });
     });

     ScrollTrigger.create({
          trigger: ".thefirstthelast-sticky-cards",
          start: "top top",
          end: `+=${window.innerHeight * 8}px`,
          pin: true,
          pinSpacing: true,
          scrub: 1,
          onUpdate: (self) => {
               const progress = self.progress;
               const totalCards = cards.length;
               const progressPerCard = 1 / totalCards;

               cards.forEach((card, index) => {
                    const cardStart = index * progressPerCard;
                    let cardProgress = (progress - cardStart) / progressPerCard;
                    cardProgress = Math.min(Math.max(cardProgress, 0), 1);

                    let yPos = window.innerHeight * (1 - cardProgress);
                    let xPos = 0;

                    if (cardProgress === 1 && index < totalCards - 1) {
                         const remainingProgress =
                              (progress - (cardStart + progressPerCard)) /
                              (1 - (cardStart + progressPerCard));
                         if (remainingProgress > 0) {
                              const distanceMultiplier = 1 - index * 0.15;
                              xPos =
                                   -window.innerWidth * 0.3 * distanceMultiplier * remainingProgress;
                              yPos =
                                   -window.innerHeight *
                                   0.3 *
                                   distanceMultiplier *
                                   remainingProgress;
                         }
                    }

                    const shouldBeVisible = index === 0 ? true : cardProgress > 0;

                    gsap.to(card, {
                         y: yPos,
                         x: xPos,
                         autoAlpha: shouldBeVisible ? 1 : 0,
                         duration: shouldBeVisible ? 0.3 : 0,
                         ease: shouldBeVisible ? "power2.out" : "none",
                    });
               });

               // Fade out intro content as first card appears
               if (introElement) {
                    const firstCardProgress = Math.min(Math.max((progress - 0) / (1 / totalCards), 0), 1);
                    const introOpacity = 1 - firstCardProgress;
                    gsap.to(introElement, {
                         autoAlpha: introOpacity,
                         duration: 0.5,
                         ease: "power2.out",
                    });
               }
          },
     });
});

export { FloatingNotes };
